export default __webpack_public_path__ + "media/Objective/Objective-Black-Italic-1dd6663cd7751aa89f5d7bb165f95127.woff2";